(() => {
  const replacePolicyEmail = () => {
    const policyBody = document.querySelector('.shopify-policy__body');
    if (!policyBody) return;

    const oldEmail = 'heldtogethercreations@gmail.com';
    const newEmail = 'info@heldtogethercreations.com';
    const walker = document.createTreeWalker(policyBody, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      if (node.nodeValue.includes(oldEmail)) {
        node.nodeValue = node.nodeValue.split(oldEmail).join(newEmail);
      }
    });

    policyBody.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      if (href.includes(oldEmail)) {
        link.setAttribute('href', href.split(oldEmail).join(newEmail));
      }
    });
  };

  const enhancePolicyPage = () => {
    const container = document.querySelector('.shopify-policy__container');
    const titleElement = document.querySelector('.shopify-policy__title h1');

    if (!container || !titleElement) return;

    const originalTitle = titleElement.textContent.trim().toLowerCase();
    const policies = {
      'privacy policy': {
        title: 'Privacy Policy',
        script: 'your details, treated properly',
        className: 'privacy'
      },
      'refund policy': {
        title: 'Refunds & Returns',
        script: 'when things don’t quite go to plan',
        className: 'refunds'
      },
      'refunds & returns': {
        title: 'Refunds & Returns',
        script: 'when things don’t quite go to plan',
        className: 'refunds'
      },
      'shipping': {
        title: 'Shipping Information',
        script: 'from Goulburn to your door',
        className: 'shipping'
      },
      'shipping policy': {
        title: 'Shipping Information',
        script: 'from Goulburn to your door',
        className: 'shipping'
      },
      'shipping information': {
        title: 'Shipping Information',
        script: 'from Goulburn to your door',
        className: 'shipping'
      },
      'terms of service': {
        title: 'Terms of Service',
        script: 'the official little details',
        className: 'terms'
      }
    };

    const policy = policies[originalTitle];
    if (!policy) return;

    document.body.classList.add('htc-policy-page', `htc-policy--${policy.className}`);
    container.classList.add('htc-policy');
    titleElement.textContent = policy.title;

    const titleWrapper = titleElement.closest('.shopify-policy__title');
    if (titleWrapper && !titleWrapper.querySelector('.htc-policy__script')) {
      const scriptLine = document.createElement('p');
      scriptLine.className = 'htc-policy__script';
      scriptLine.textContent = policy.script;
      titleElement.insertAdjacentElement('afterend', scriptLine);
    }

    replacePolicyEmail();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePolicyPage, { once: true });
  } else {
    enhancePolicyPage();
  }
})();
